export const formData = [
  {
    name: 'site_name',
    lable: '网站名称',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'wxapp_cover',
    lable: '二维码背景图',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'wxapp_cover_two',
    lable: '二维码背景图2',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'wxapp_covers',
    lable: '二维码图',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_slide_promoter_user',
    lable: '推广员个人中心广告位',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_slide_doctor_index',
    lable: '医生首页广告位',
    lableCol: 6,
    wrapperCol: 16,
  },

  {
    name: 'site_slide_doctor_user',
    lable: '医生个人中心广告位',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_video_vframe',
    lable: '视频封面设置',
    lableCol: 6,
    wrapperCol: 16,
  },

  {
    name: 'site_pop_task_receive_notification',
    lable: '推广端任务接收通知模版	',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_pop_bangding_notification',
    lable: '推广端医生绑定通知模版',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_pop_fankui_notification',
    lable: '推广端医生反馈任务通知模版',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_task_receive_notification',
    lable: '医生端任务接收通知模版',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_message_notification',
    lable: '推广端留言通知',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_doctor_message_notification',
    lable: '医生端留言通知',
    lableCol: 6,
    wrapperCol: 16,
  },

  {
    name: 'site_seo_title',
    lable: 'SEO标题',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_seo_keywords',
    lable: 'SEO关键字',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_seo_description',
    lable: 'SEO描述',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'survey_img',
    lable: '调研报告封面图',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'task_one_img',
    lable: '线上拜访图标',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'task_two_img',
    lable: '学术调研图标',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'task_three_img',
    lable: '线上科室会图标',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'wxapp_api_cover',
    lable: 'app显示二维码背景图',
    lableCol: 6,
    wrapperCol: 16,
  },
];

export const formDataAli=[
  {
    name: 'site_accessKeyId',
    lable: 'accessKeyId',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_accessSecret',
    lable: 'accessSecret',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'site_signName',
    lable: '签名名称',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'register_sms_code',
    lable: '用户注册模板CODE',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'login_sms_code',
    lable: '用户登录模板CODE',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'change_sms_code',
    lable: '修改密码模板CODE',
    lableCol: 6,
    wrapperCol: 16,
  },
];
export const formDataComment=[
  {
    name: 'brush_infoList',
    lable: '文章评论内容',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'video_infoList',
    lable: '视频评论内容',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'task_infoList',
    lable: '任务推广反馈内容',
    lableCol: 6,
    wrapperCol: 16,
  },
];
export const formDataMini=[
  {
    name: 'popularize_app_id',
    lable: '推广端appid',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'popularize_app_secret',
    lable: '推广端appsecret',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'doctor_app_id',
    lable: '医生端appid',
    lableCol: 6,
    wrapperCol: 16,
  },
  {
    name: 'doctor_app_secret',
    lable: '医生端appsecret',
    lableCol: 6,
    wrapperCol: 16,
  },
];